import { Box, List, ListItemWithIcon, Typography } from "@bca/ui-library";

import { Item } from "../vehicleDetails/vehicle-details.type";

interface EquipmentProps {
  equipmentItems?: Item[];
}

const EquipmentSection = ({ equipmentItems }: EquipmentProps) => {
  if (Boolean(equipmentItems) && equipmentItems?.length > 0)
    return (
      <Box marginBottom="44px">
        <Typography variant="h5" css="margin: 0 0 24px 0;">
          Equipment
        </Typography>
        <Box display="flex" flexWrap="wrap" justifyContent="flex-start">
          <List
            css={`
              margin-top: 0;
              padding-top: 0;
            `}
          >
            {equipmentItems?.map((item) => (
              <ListItemWithIcon
                icon="circle"
                iconColor="grey-blue"
                iconWeight="solid"
                iconWidth={5}
                key={item?.name}
              >
                {item?.name}
              </ListItemWithIcon>
            ))}
          </List>
        </Box>
      </Box>
    );
  return (
    <Box marginBottom="44px" marginTop={{ mobile: 0, tablet: 0, desktop: 0 }}>
      <Typography variant="h5" css="margin: 0 0 24px 0;">
        Equipment
      </Typography>
      <Typography
        variant="body"
        fontStyle="italic"
        color="grey-blue"
        fontWeight="normal"
      >
        No equipment listed
      </Typography>
    </Box>
  );
};

export default EquipmentSection;
